const config = {
    api_end_point: process.env.REACT_APP_API_ROOT,
};

export default config;
